import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import ListMarketingByGetMarketing from "./ListMarketingByGetMarketing";
import "./CabangKunjunganMarketing.css";

function CabangKunjunganMarketing() {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [sendDataMarketing, setSendDataMarketing] = React.useState([]);
  const [sendDataCabang, setSendDataCabang] = React.useState([]);

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_MARKETING", data: false });
    setSendDataMarketing(val.marketing);
    setSendDataCabang(val.cabang);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  React.useEffect(() => {
    let tmp =
      kunjungan.dataGetMarketing &&
      kunjungan.dataGetMarketing.map((val) => {
        return {
          ...val,
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-red"
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListDataMarketing(tmp);
  }, [kunjungan.dataGetMarketing]);

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px", // override the row height
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Kode Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) => row.kodeCabang,
    },
    {
      name: "Nama Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) => row.namaCabang,
    },
    {
      name: "Total Kunjungan",
      minWidth: "250px",
      center: true,
      selector: (row) => `${row.totalKunjungan} Kunjungan`,
    },
    {
      name: "Total Marketing",
      minWidth: "250px",
      center: true,
      selector: (row) => `${row.marketing.length} Marketing`,
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      {kunjungan.detailGetMarketing ? (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="kunjungan-card">
                <Card.Header className="kunjungan-card-header">
                  <Card.Title as="h3" className="kunjungan-title">
                    Daftar Kunjungan Cabang
                  </Card.Title>
                  <p className="kunjungan-subtitle">
                    Pantau total kunjungan dan jumlah sales marketing aktif
                    berdasarkan wilayah cabang
                  </p>
                </Card.Header>
                <Card.Body>
                  <div className="date-filter-section">
                    <div className="date-filter-title">
                      <i className="fas fa-filter"></i> Filter Periode Kunjungan
                    </div>
                    <Row>
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        className="mb-3 mb-sm-0"
                      >
                        <label className="small font-weight-bold text-muted mb-1">
                          <i className="fas fa-calendar-alt mr-1"></i> Tanggal
                          Awal
                        </label>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              color: "#334155",
                              backgroundColor: "#ffffff",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1",
                            },
                          }}
                          onChange={(e) => {
                            if (typeof e === "object" && e.toDate) {
                              e.toDate().setHours(0, 0, 0, 0);
                              setTglAwal(e.toDate().setHours(0, 0, 0, 0));
                            } else {
                              setTglAwal(e);
                            }
                          }}
                          value={tglAwal}
                          initialValue={tglAwal}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <label className="small font-weight-bold text-muted mb-1">
                          <i className="fas fa-calendar-alt mr-1"></i> Tanggal
                          Akhir
                        </label>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Pilih Tanggal",
                            readOnly: true,
                            style: {
                              cursor: "pointer",
                              color: "#334155",
                              backgroundColor: "#ffffff",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1",
                            },
                          }}
                          onChange={(e) => {
                            if (typeof e === "object" && e.toDate) {
                              e.toDate().setHours(0, 0, 0, 0);
                              setTglAkhir(e.toDate().setHours(0, 0, 0, 0));
                            } else {
                              setTglAkhir(e);
                            }
                          }}
                          value={tglAkhir}
                          initialValue={tglAkhir}
                          timeFormat={false}
                          closeOnSelect={true}
                        />
                      </Col>
                    </Row>
                  </div>

                  {isLoading ? (
                    <div className="loader-container">
                      <Watch
                        visible={true}
                        height="60"
                        width="60"
                        radius="30"
                        color="#F75D59"
                        ariaLabel="watch-loading"
                      />
                      <p>Memuat data kunjungan cabang...</p>
                    </div>
                  ) : (
                    <div>
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={itemsPerPage}
                        onChangePage={handlePageChange}
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <ListMarketingByGetMarketing
            data={sendDataMarketing}
            cabang={sendDataCabang}
          />
        </>
      )}
    </>
  );
}

export default CabangKunjunganMarketing;
